import { render } from "./News10.vue?vue&type=template&id=a6ac6fc6"
import script from "./News10.vue?vue&type=script&lang=js"
export * from "./News10.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__